<div class="col-md-12 mt-2">
  <!--
    A segmented control rather than three separate filled buttons. The old tabs
    carried their state in a full blue / amber / green fill, which made the
    loudest thing on screen a three-way switch. The status colour is now a dot;
    selection is carried by the raised white segment.
  -->
  <div class="tab-wrapper">
    <div class="study-tabs" role="tablist" aria-label="Submission stage">
      <button type="button"
              role="tab"
              class="study-tab"
              [class.is-active]="viewMode === ViewMode.UPLOAD || viewMode === ViewMode.DRAFT"
              [attr.aria-selected]="viewMode === ViewMode.UPLOAD || viewMode === ViewMode.DRAFT"
              (click)="setViewMode(ViewMode.UPLOAD)"
              *ngIf="isUserHasUploadAccess && !isViewerOnly">
        <span class="study-tab__dot study-tab__dot--upload" aria-hidden="true"></span>
        Upload
      </button>
      <button type="button"
              role="tab"
              class="study-tab"
              [class.is-active]="viewMode === ViewMode.IN_REVIEW"
              [attr.aria-selected]="viewMode === ViewMode.IN_REVIEW"
              (click)="setViewMode(ViewMode.IN_REVIEW)"
              *ngIf="!isViewerOnly">
        <span class="study-tab__dot study-tab__dot--review" aria-hidden="true"></span>
        In Review
      </button>
      <button type="button"
              role="tab"
              class="study-tab"
              [class.is-active]="viewMode === ViewMode.APPROVED"
              [attr.aria-selected]="viewMode === ViewMode.APPROVED"
              (click)="setViewMode(ViewMode.APPROVED)">
        <span class="study-tab__dot study-tab__dot--approved" aria-hidden="true"></span>
        Approved
      </button>
    </div>
  </div>
</div>
<div>
  <ng-container
    *ngIf="
      (viewMode === ViewMode.DRAFT || viewMode === ViewMode.UPLOAD) &&
      isUserHasUploadAccess
    "
  >
    <app-upload-study
      [saleId]="saleId"
      [horseId]="horseId"
      [studyId]="studyId"
      [saleName]="saleName"
      [horseName]="horseName"
      [lot]="lot"
      [lotOrHipText]="lotOrHipText"
      [catalogDataSource]="catalogDataSource"
      [autoApproveSubmissions]="autoApproveSubmissions"
      [mediaCategories]="mediaCategories$ | async"
      [missingMediaCategories]="missingMediaCategories$ | async"
      [saleSettings]="saleSettings$ | async"
      (closedClicked)="closeModal()"
    ></app-upload-study>
  </ng-container>

  <ng-container *ngIf="viewMode === ViewMode.IN_REVIEW">
    <app-review-study
      [isUserSaleEditor]="isUserSaleEditor"
      [isVetEditor]="isUserHasUploadAccess"
      [isViewerOnly]="isViewerOnly"
      [saleSettings]="saleSettings$ | async"
    ></app-review-study>
  </ng-container>

  <ng-container *ngIf="viewMode === ViewMode.APPROVED">
    <app-approved-study
      [isViewerOnly]="isViewerOnly"
      [disclosedClient]="disclosedClient"
      (disclosedClientChanged)="disclosedClientChanged($event)"
      [isViewXraysAllowed]="isViewXraysAllowed"
      [viewXrayValidationMessage]="viewXrayValidationMessage"
      [saleSettings]="saleSettings$ | async"
    ></app-approved-study>
  </ng-container>
</div>
